// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageDetail_container__Guxtk {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ImageDetail_container__Guxtk::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
}

.ImageDetail_container__Guxtk::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ImageDetail_container__Guxtk::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ImageDetail_section__3Jn0v,
.ImageDetail_section_error__soPO6 {
    width: 60%;
    margin-top: 50px;
}

.ImageDetail_section_error__soPO6 {
    font-size: 22px;
}

.ImageDetail_div_line__2tOFT {
    width: 100%;
    padding: 1px;
    border-bottom: 1px solid #D9D9D9;
    margin: 60px 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/detail/components/ImageDetail/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,kDAA+B,UAAU;IACrC,wBAAwB;IACxB,WAAW;IACX,YAAY;AAChB;;AAEA,wDAAqC,WAAW;IAC5C,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,cAAc;AAClB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.container::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 10px;\n    height: 10px;\n}\n\n.container::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.container::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.section,\n.section_error {\n    width: 60%;\n    margin-top: 50px;\n}\n\n.section_error {\n    font-size: 22px;\n}\n\n.div_line {\n    width: 100%;\n    padding: 1px;\n    border-bottom: 1px solid #D9D9D9;\n    margin: 60px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ImageDetail_container__Guxtk`,
	"section": `ImageDetail_section__3Jn0v`,
	"section_error": `ImageDetail_section_error__soPO6`,
	"div_line": `ImageDetail_div_line__2tOFT`
};
export default ___CSS_LOADER_EXPORT___;
